﻿import * as $ from 'jquery';

export function correctHeight() {

    let pageWrapper = $('#page-wrapper');
    let navbarHeight = $('nav.navbar-default').height();
    let wrapperHeight = pageWrapper.height();

    if (navbarHeight > wrapperHeight) {
        pageWrapper.css('min-height', navbarHeight + 'px');
    }

    if (navbarHeight <= wrapperHeight) {
        if (navbarHeight < $(window).height()) {
            pageWrapper.css('min-height', $(window).height() + 'px');
        } else {
            pageWrapper.css('min-height', navbarHeight + 'px');
        }
    }

    if ($('body').hasClass('fixed-nav')) {
        if (navbarHeight > wrapperHeight) {
            pageWrapper.css('min-height', navbarHeight + 'px');
        } else {
            pageWrapper.css('min-height', $(window).height() - 60 + 'px');
        }
    }
}

export function detectBody() {
    if ($(document).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }
}

export function smoothlyMenu() {
    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide();
        // For smoothly turn on menu
        setTimeout(
            function () {
                $('#side-menu').fadeIn(400);
            }, 200);
    } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide();
        setTimeout(
            function () {
                $('#side-menu').fadeIn(400);
            }, 100);
    } else {
        // Remove all inline style from $ fadeIn function to reset menu state
        $('#side-menu').removeAttr('style');
    }
}

export function SwapBox(boxToShow) {

    $('.swapBox').removeClass('fadeInDown');
    $('.swapBox').addClass('fadeOutUp');

    $('.swapBox.active').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        $('.swapBox.active').removeClass('.active');

        $('.swapBox').addClass('hide');

        $(boxToShow).removeClass('fadeOutUp');
        $(boxToShow).removeClass('hide');
        $(boxToShow).addClass('fadeInDown');
        $(boxToShow).addClass('active');
    });

}
